
// ABOUTME: Manage roles page with URL routing support
// ABOUTME: Handles role management and navigation to filtered HR dashboard

import React from 'react';
import ManageRoles from '@/components/admin/ManageRoles';
import { useNavigate } from 'react-router-dom';

const ManageRolesPage = () => {
  const navigate = useNavigate();

  const handleViewChange = (view: string, filters?: { jobRoleId?: string; jobRoleTitle?: string }) => {
    switch (view) {
      case 'dashboard':
        navigate('/');
        break;
      case 'submit':
        navigate('/role-hub');
        break;
      case 'public-profile':
        navigate('/my-profile');
        break;
      case 'hr-dashboard':
        if (filters?.jobRoleId) {
          navigate(`/hr/roles/${filters.jobRoleId}`);
        } else {
          navigate('/hr');
        }
        break;
      case 'billing':
        navigate('/billing');
        break;
      case 'security-audit':
        navigate('/security-audit');
        break;
      default:
        navigate('/manage-roles');
    }
  };

  return <ManageRoles onViewChange={handleViewChange} />;
};

export default ManageRolesPage;
